/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

import React from 'react';
import classNames from 'classnames';
import { CloseIcon } from 'tdesign-icons-react';
import useGlobalIcon from '../hooks/useGlobalIcon.js';
import { useMessageClass } from './useMessageClass.js';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-74ef9ead.js';
import '../_chunks/dep-5eadc4f3.js';
import '../_chunks/dep-7a9656a6.js';
import '../_chunks/dep-fd215ab0.js';
import '../_chunks/dep-8127363b.js';
import '../_chunks/dep-a0b71ae4.js';
import '../_chunks/dep-670cc86e.js';
import '../_chunks/dep-da112583.js';
import '../_chunks/dep-dfae10c3.js';
import '../_chunks/dep-f4495ac9.js';
import '../_chunks/dep-6c09308a.js';
import '../_chunks/dep-4ca52001.js';
import '../_chunks/dep-408df89a.js';
import '../_chunks/dep-e755a9cb.js';
import '../_chunks/dep-1e4c771d.js';
import '../_chunks/dep-15d0e734.js';
import '../_chunks/dep-b0c02324.js';
import '../_chunks/dep-a09b6dac.js';
import '../_chunks/dep-1792ab93.js';
import '../_chunks/dep-9c2f4c72.js';
import '../_chunks/dep-da7344ec.js';
import '../_chunks/dep-01fe0fd1.js';
import '../_chunks/dep-20a8e46d.js';
import '../_chunks/dep-9d067299.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_common/js/global-config/default-config.js';

function MessageClose(_ref) {
  var closeBtn = _ref.closeBtn,
    onCloseBtnClick = _ref.onCloseBtnClick;
  var _useMessageClass = useMessageClass(),
    tdMessageClassGenerator = _useMessageClass.tdMessageClassGenerator;
  var _useGlobalIcon = useGlobalIcon({
      CloseIcon: CloseIcon
    }),
    CloseIcon$1 = _useGlobalIcon.CloseIcon;
  var relCloseBtn = closeBtn;
  if (typeof closeBtn === "function") {
    relCloseBtn = closeBtn();
  }
  if (!relCloseBtn) {
    return null;
  }
  if (typeof relCloseBtn === "string" || typeof relCloseBtn === "number") {
    return /* @__PURE__ */React.createElement("span", {
      className: tdMessageClassGenerator("close"),
      onClick: function onClick(e) {
        return onCloseBtnClick === null || onCloseBtnClick === void 0 ? void 0 : onCloseBtnClick({
          e: e
        });
      }
    }, closeBtn);
  }
  if ( /*#__PURE__*/React.isValidElement(relCloseBtn)) {
    var _onClick = relCloseBtn.props.onClick;
    return /*#__PURE__*/React.cloneElement(relCloseBtn, {
      className: classNames(relCloseBtn.props.className, tdMessageClassGenerator("close")),
      onClick: function onClick(e) {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
        onCloseBtnClick === null || onCloseBtnClick === void 0 ? void 0 : onCloseBtnClick({
          e: e
        });
      }
    });
  }
  return /* @__PURE__ */React.createElement(CloseIcon$1, {
    className: tdMessageClassGenerator("close"),
    onClick: function onClick(e) {
      return onCloseBtnClick === null || onCloseBtnClick === void 0 ? void 0 : onCloseBtnClick({
        e: e
      });
    }
  });
}

export { MessageClose as default };
//# sourceMappingURL=MessageClose.js.map
